import type { ReactNode } from 'react';

interface AlertProps {
  tone: 'error' | 'info';
  children: ReactNode;
}

const TONES = {
  error: 'border-buds-danger/30 bg-buds-danger/5 text-buds-danger',
  info: 'border-buds-mint/40 bg-buds-mint/10 text-buds-dark',
} as const;

export function Alert({ tone, children }: AlertProps) {
  return (
    <p
      // Errors interrupt; confirmations are announced politely.
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
      className={`rounded-xl border px-4 py-3 text-sm leading-relaxed ${TONES[tone]}`}
    >
      {children}
    </p>
  );
}
